/**
 * Base URL for ViewThru pre-sign endpoints (/viewthru/verify, /viewthru/check-otp).
 * Falls back to deriving from REACT_APP_API_SIGN_URL when REACT_APP_API_VIEWTHRU_VERIFY_URL is unset.
 */
export const getViewThruVerifyBaseUrl = (): string => {
    const explicit = process.env.REACT_APP_API_VIEWTHRU_VERIFY_URL?.trim()
    if (explicit) return explicit.replace(/\/$/, '')

    const signUrl = process.env.REACT_APP_API_SIGN_URL?.trim()
    if (!signUrl) return ''

    return signUrl.replace(/\/sign-documents\/?$/, '')
}

export type ViewThruVerifyResponse = {
    success: boolean
    decision?: 'ALLOW' | 'CHALLENGE' | 'BLOCK'
    verification_id?: string
    message?: string
}

export type ViewThruCheckOtpResponse = {
    success: boolean
    decision?: 'ALLOW'
    verification_id?: string
    message?: string
}
